import {
    InvoiceClient_V1,
    InvoiceDTO,
    InvoiceSearchDTO,
    AttachmentInfoDTO,
    InvoiceStatementDTO,
    ExportDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class InvoiceService {
    private readonly _invoiceClient: InvoiceClient_V1;

    constructor() {
        this._invoiceClient = new InvoiceClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Invoices(dealerAccountUid : string, dto: InvoiceSearchDTO): Promise<Array<InvoiceDTO>> {
        return this._invoiceClient.invoices(dto, dealerAccountUid);
    }

    public InvoiceReport(dealerAccountUid : string, invoiceId: string | null | undefined): Promise<AttachmentInfoDTO> {
        return this._invoiceClient.invoiceReport(dealerAccountUid, invoiceId);
    }

    public InvoiceStatement(dealerAccountUid : string): Promise<InvoiceStatementDTO> {
        return this._invoiceClient.invoiceStatement(dealerAccountUid);
    }

    public ExportInvoiceStatement(dealerAccountUid : string): Promise<ExportDTO> {
        return this._invoiceClient.exportInvoiceStatement(dealerAccountUid);
    }

}